import React from 'react';
import { Form, Select } from "antd";
import { useQuery } from "@apollo/client";
import { GET_LANGUAGES_ALL } from "graphql/query/language-gql";
import Language from "components/language";
import Icons from "components/icons";
import { Localize } from "components/service";


const UserLanguageSelect = ({
    disabled = false,
    rules = true,
    initialValue,
    mode = '',
    name = 'language_slug',
    label = Localize({ children: "FORMS.Input_Label_Language" }).props.children
}) => {

    const { data, loading } = useQuery(GET_LANGUAGES_ALL, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
    });

    const languages = Language.Helpers.Options.toOptions(data?.languagesAll || []);

    return (
        <Form.Item
            name={ name }
            label={ label }
            initialValue={ initialValue }
            rules={ rules && [ { required: true, message: `${ Localize({ children: "FORM_RULES.Required_Choose" }).props.children } ${ label }` } ] }
        >
            <Select
                showSearch
                suffixIcon={ <Icons.Arrow /> }
                mode={ mode }
                className="select-serch-input"
                disabled={ disabled }
                loading={ loading }
                placeholder={ `${ Localize({ children: "FORMS.Input_Placeholder_Choose" }).props.children } ${ label }` }
                dropdownClassName="select-serch-dropdown"
                optionFilterProp="children"
            >

                { languages.map((language) => (
                    <Select.Option
                        key={ language.slug }
                        value={ language.slug }
                        disabled={ language.status === false }
                    >
                        { language.label }
                    </Select.Option>
                )) }

            </Select>
        </Form.Item>
    );

}

export default UserLanguageSelect;


